import { render, staticRenderFns } from "./ConsulationTempV2.vue?vue&type=template&id=0dd51432"
import script from "./ConsulationTempV2.vue?vue&type=script&lang=js"
export * from "./ConsulationTempV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports